import {Component} from '@angular/core';

@Component({
    selector: 'app-about-rana',
    templateUrl: './about-rana.component.html',
    styleUrl: './about-rana.component.css'
})
export class AboutRanaComponent {

}
